//TODO COMPLETED DATE LIST
export const USER_TODO_COMPLETED_LIST_REQUEST =
  'USER_TODO_COMPLETED_LIST_REQUEST';
export const USER_TODO_COMPLETED_LIST_SUCCESS =
  'USER_TODO_COMPLETED_LIST_SUCCESS';
export const USER_TODO_COMPLETED_LIST_FAIL = 'USER_TODO_COMPLETED_LIST_FAIL';

//TODO INCOMPLETE LIST
export const USER_TODO_INCOMPLETE_LIST_REQUEST =
  'USER_TODO_INCOMPLETE_LIST_REQUEST';
export const USER_TODO_INCOMPLETE_LIST_SUCCESS =
  'USER_TODO_INCOMPLETE_LIST_SUCCESS';
export const USER_TODO_INCOMPLETE_LIST_FAIL = 'USER_TODO_INCOMPLETE_LIST_FAIL';

//PREV TODO COMPLETED LIST
export const USER_PREV_TODO_COMPLETED_LIST_REQUEST =
  'USER_PREV_TODO_COMPLETED_LIST_REQUEST';
export const USER_PREV_TODO_COMPLETED_LIST_SUCCESS =
  'USER_PREV_TODO_COMPLETED_LIST_SUCCESS';
export const USER_PREV_TODO_COMPLETED_LIST_FAIL =
  'USER_PREV_TODO_COMPLETED_LIST_FAIL';

//TODO COMPLETED TIMING LIST
export const USER_TODO_COMPLETED_TIME_LIST_REQUEST =
  'USER_TODO_COMPLETED_TIME_LIST_REQUEST';
export const USER_TODO_COMPLETED_TIME_LIST_SUCCESS =
  'USER_TODO_COMPLETED_TIME_LIST_SUCCESS';
export const USER_TODO_COMPLETED_TIME_LIST_FAIL =
  'USER_TODO_COMPLETED_TIME_LIST_FAIL';

//TODO COMPLETED TOTAL LIST
export const USER_TODO_TOTAL_COMPLETED_LIST_REQUEST =
  'USER_TODO_TOTAL_COMPLETED_LIST_REQUEST';
export const USER_TODO_TOTAL_COMPLETED_LIST_SUCCESS =
  'USER_TODO_TOTAL_COMPLETED_LIST_SUCCESS';
export const USER_TODO_TOTAL_COMPLETED_LIST_FAIL =
  'USER_TODO_TOTAL_COMPLETED_LIST_FAIL';

//TODO TOTAL LIST
export const USER_TODO_TOTAL_LIST_REQUEST = 'USER_TODO_TOTAL_LIST_REQUEST';
export const USER_TODO_TOTAL_LIST_SUCCESS = 'USER_TODO_TOTAL_LIST_SUCCESS';
export const USER_TODO_TOTAL_LIST_FAIL = 'USER_TODO_TOTAL_LIST_FAIL';

//TODO MONTH TIME LIST
export const USER_TODO_TIME_MONTH_LIST_REQUEST =
  'USER_TODO_TIME_MONTH_LIST_REQUEST';
export const USER_TODO_TIME_MONTH_LIST_SUCCESS =
  'USER_TODO_TIME_MONTH_LIST_SUCCESS';
export const USER_TODO_TIME_MONTH_LIST_FAIL = 'USER_TODO_TIME_MONTH_LIST_FAIL';

//TODO TODAY LIST
export const USER_TODO_TODAY_LIST_REQUEST = 'USER_TODO_TODAY_LIST_REQUEST';
export const USER_TODO_TODAY_LIST_SUCCESS = 'USER_TODO_TODAY_LIST_SUCCESS';
export const USER_TODO_TODAY_LIST_FAIL = 'USER_TODO_TODAY_LIST_FAIL';

//TODO DELETE
export const USER_TODO_DELETE_REQUEST = 'USER_TODO_DELETE_REQUEST';
export const USER_TODO_DELETE_SUCCESS = 'USER_TODO_DELETE_SUCCESS';
export const USER_TODO_DELETE_FAIL = 'USER_TODO_DELETE_FAIL';

//Add TODO TIME
export const USER_ADD_TODO_TIME_REQUEST = 'USER_ADD_TODO_TIME_REQUEST';
export const USER_ADD_TODO_TIME_SUCCESS = 'USER_ADD_TODO_TIME_SUCCESS';
export const USER_ADD_TODO_TIME_FAIL = 'USER_ADD_TODO_TIME_FAIL';